import styled from 'styled-components';

import { hideScrollbar } from 'styles';

export const HighlightsContainer = styled.div`
	gap: 20px;
	display: flex;
	display: flex;
	width: fit-content;

	${hideScrollbar}

	::-webkit-scrollbar {
		display: none;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		margin: auto;
	}
`;
